module.exports = __webpack_public_path__ + "static/img/fucerep.d537bdb1.png";